module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "chartForm",
    staticClass: "demo-dynamic",
    attrs: {
      "model": _vm.chart,
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    staticClass: "w-300",
    attrs: {
      "label": "图表宽度"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chart.style.width),
      expression: "chart.style.width"
    }],
    attrs: {
      "placeholder": "图表宽度"
    },
    domProps: {
      "value": (_vm.chart.style.width)
    },
    on: {
      "input": function($event) {
        _vm.chart.style.width = $event
      }
    }
  })]), _vm._v(" "), _vm._v(" "), _c('el-form-item', {
    staticClass: "w-300",
    attrs: {
      "label": "图表高度"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chart.style.height),
      expression: "chart.style.height"
    }],
    attrs: {
      "placeholder": "图表高度"
    },
    domProps: {
      "value": (_vm.chart.style.height)
    },
    on: {
      "input": function($event) {
        _vm.chart.style.height = $event
      }
    }
  })]), _vm._v(" "), _vm._v(" "), _c('el-form-item', {
    staticClass: "w-300",
    attrs: {
      "label": "X坐标轴名"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chart.tableData[0].name),
      expression: "chart.tableData[0].name"
    }],
    attrs: {
      "placeholder": "X坐标轴名"
    },
    domProps: {
      "value": (_vm.chart.tableData[0].name)
    },
    on: {
      "input": function($event) {
        _vm.chart.tableData[0].name = $event
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    staticClass: "w-300",
    attrs: {
      "label": "柱宽"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chart.tableData[0].barWidth),
      expression: "chart.tableData[0].barWidth"
    }],
    attrs: {
      "placeholder": "柱宽"
    },
    domProps: {
      "value": (_vm.chart.tableData[0].barWidth)
    },
    on: {
      "input": function($event) {
        _vm.chart.tableData[0].barWidth = $event
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "X坐标字段"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chart.tableData[0].x_axis),
      expression: "chart.tableData[0].x_axis"
    }],
    attrs: {
      "placeholder": "请选择"
    },
    domProps: {
      "value": (_vm.chart.tableData[0].x_axis)
    },
    on: {
      "change": _vm.xaxisChange,
      "input": function($event) {
        _vm.chart.tableData[0].x_axis = $event
      }
    }
  }, _vm._l((_vm.chart.fields), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.field,
        "value": item.field
      }
    })
  }))]), _vm._v(" "), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "系列"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chart.tableData[2].series),
      expression: "chart.tableData[2].series"
    }],
    attrs: {
      "placeholder": "请选择"
    },
    domProps: {
      "value": (_vm.chart.tableData[2].series)
    },
    on: {
      "input": function($event) {
        _vm.chart.tableData[2].series = $event
      }
    }
  }, _vm._l((_vm.chart.fields), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.field,
        "value": item.field
      }
    })
  }))]), _vm._v(" "), _vm._v(" "), _c('el-form-item', {
    staticClass: "w-300",
    attrs: {
      "label": "y坐标轴名"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chart.tableData[1].name),
      expression: "chart.tableData[1].name"
    }],
    attrs: {
      "placeholder": "y坐标轴名"
    },
    domProps: {
      "value": (_vm.chart.tableData[1].name)
    },
    on: {
      "input": function($event) {
        _vm.chart.tableData[1].name = $event
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    staticClass: "w-300",
    attrs: {
      "label": "计算方式"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chart.tableData[1].calculate_type),
      expression: "chart.tableData[1].calculate_type"
    }],
    domProps: {
      "value": (_vm.chart.tableData[1].calculate_type)
    },
    on: {
      "change": _vm.calculateChange,
      "input": function($event) {
        _vm.chart.tableData[1].calculate_type = $event
      }
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 10
    }
  }, [_vm._v("计量")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 20
    }
  }, [_vm._v("计数")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "y坐标字段"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chart.tableData[1].y_axis),
      expression: "chart.tableData[1].y_axis"
    }],
    attrs: {
      "disabled": _vm.disableYField,
      "placeholder": "请选择"
    },
    domProps: {
      "value": (_vm.chart.tableData[1].y_axis)
    },
    on: {
      "input": function($event) {
        _vm.chart.tableData[1].y_axis = $event
      }
    }
  }, _vm._l((_vm.chart.fields), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.field,
        "value": item.field
      }
    })
  }))]), _vm._v(" "), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTimeSelect),
      expression: "showTimeSelect"
    }],
    attrs: {
      "label": "时间粒度"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chart.time_unit),
      expression: "chart.time_unit"
    }],
    attrs: {
      "placeholder": "请选择"
    },
    domProps: {
      "value": (_vm.chart.time_unit)
    },
    on: {
      "input": function($event) {
        _vm.chart.time_unit = $event
      }
    }
  }, _vm._l((_vm.timeOptions), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ceba4152!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/classify/chartConfigs/barChartConfig.vue
// module id = 1992
// module chunks = 2